<!-- Pmc处理 -->
<template>
  <div class="client_form workOrderTem">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="150px" class="demo-ruleForm">

      <el-form-item :label="$t('workOrder.inventory_date')" prop="warehousing">
        <el-date-picker v-model="form.warehousing" type="date" value-format="timestamp" :clearable="false" style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.ship_date')" prop="ship_date">
        <el-date-picker v-model="form.ship_date" type="date" :disabled="true" value-format="timestamp" style="width: 100%;" />
      </el-form-item>

      <el-form-item :label="$t('workOrder.remark')" prop="description">
        <el-input v-model="form.description" type="textarea" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.handler')" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.processing_time')" prop="handleTime">
        <el-date-picker v-model="form.handleTime" type="datetime" :clearable="false" default-time="14:00:00" value-format="timestamp" style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.state_flow')" prop="status">
        <el-select v-model="form.status" style="width: 100%;">
          <template v-for="item in statusOptions">
            <el-option :label="$t('workOrder.'+ item.label)" :value="item.value" />
          </template>
        </el-select>
      </el-form-item>

      <el-form-item class="btnWarp">
        <el-button type="primary" :disabled="subDisabled" @click="submitForm('ruleForm')">{{ isEdit?$t('workOrder.Revise'): $t('workOrder.save') }}</el-button>
        <el-button @click="clickCancel('quxiao')">{{ $t('workOrder.cancel') }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { isObjectValueEqual } from '@/utils'
export default {
  components: {},
  props: {
    raw: {}
  },
  data() {
    return {
      attrArr: ['description', 'handleTime', 'name', 'ship_date', 'status', 'warehousing', 'status'], // 需要对比的属性
      initObj: {}, // 判断是否有改变项--初始化时的值
      newObj: {}, // 判断是否有改变项--最新的值
      subDisabled: false,
      form: {
        description: '',
        handleTime: new Date().getTime(),
        name: '',
        ship_date: '',
        status: 100,
        warehousing: new Date().setHours(0, 0, 0, 0)
      },
      user: [],
      statusOptions: [
        { label: 'finish', value: 100 },
        { label: 'line_handling', value: 5 },
        { label: 'repair_processing', value: 4 }
      ],
      isEdit: false// 修改
    }
  },
  computed: {
    rules() {
      return {
        shipping: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        warehousing: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        handleTime: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    raw: {
      deep: true,
      handler(obj) {
        this.initForm(obj)
      }
    }
  },
  mounted() {
    this.initForm(this.raw)
  },
  methods: {
    initForm(raw) {
      console.log('PMC：raw', raw)
      this.isEdit = false
      if (raw.step6) {
        this.form = JSON.parse(raw.step6)
        this.isEdit = true
      }
      var device = this.$storage.get('dtuDeviceInfo') || {}
      this.form.ship_date = device.orderDate ? new Date(device.orderDate).getTime() : ''
      var configList = this.$storage.get('configList') || []
      configList.forEach((v, i) => {
        if (v.key == 'user') {
          this.user = v.valueList || []
        }
      })
      this.initObj = this.getObjFn(this.form)
      console.log('initForm:this.form', this.form)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.user && this.form.name != this.user[4]) {
          //   this.$message({
          //     type: 'error',
          //     message: this.$t('workOrder.notPermission')// '提交失败，该处理人无权限，请联系部门负责人'
          //   })
          //   return
          // }
          this.subDisabled = true
          setTimeout(() => {
            this.subDisabled = false
          }, 2000)

          const form = {}
          for (const key in this.raw) {
            if (Object.hasOwnProperty.call(this.raw, key)) {
              const element = this.raw[key]
              form[key] = element
            }
          }
          form.status = this.form.status
          // form.status = 100
          form.step6 = JSON.stringify(this.form)
          this.$emit('save', form)
          console.log(form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    clickCancel(val) {
      this.newObj = this.getObjFn(this.form)
      this.$emit('back', this.initObj, this.newObj, val)
    },
    getObjFn(obj) {
      var newObj = {}
      this.attrArr.forEach(v => {
        newObj[v] = obj[v]
      })
      return newObj
    }
  }
}
</script>

<style lang='scss' scoped>
.client_form {
  width: 700px;
  margin: 20px auto;
}
</style>
